module.exports = __webpack_public_path__ + "img/t.f943ed18.svg";